import { render, staticRenderFns } from "./addGarbage.vue?vue&type=template&id=54f60879&scoped=true"
import script from "./addGarbage.vue?vue&type=script&lang=js"
export * from "./addGarbage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f60879",
  null
  
)

export default component.exports